/**
 * Store location service - uses the same API as Seller-Web (locate.beetletz.store)
 * for surveyed locations in Tanzania.
 */
const LOCATION_API_URL =
  process.env.NODE_ENV === 'development'
    ? (process.env.REACT_APP_LOCATION_API_URL || 'https://locate.beetletz.store')
    : (process.env.REACT_APP_LOCATION_API_URL || 'https://locate.beetletz.store');

const normalize = (data) => {
  if (Array.isArray(data)) return data;
  const keys = ['regions', 'Regions', 'data', 'councils', 'Councils', 'wards', 'Wards', 'streets', 'Streets', 'roads', 'Roads'];
  for (const key of keys) {
    if (data[key] && Array.isArray(data[key])) return data[key];
  }
  return [];
};

async function fetchApi(url, options = {}) {
  const res = await fetch(url, {
    ...options,
    headers: { 'Content-Type': 'application/json', ...options.headers },
  });
  if (!res.ok) throw new Error(`Location API error: ${res.status}`);
  return res.json();
}

export async function fetchRegions() {
  const data = await fetchApi(`${LOCATION_API_URL}/regions`);
  return normalize(data);
}

export async function fetchCouncils(regionId) {
  const data = await fetchApi(`${LOCATION_API_URL}/councils`, {
    method: 'POST',
    body: JSON.stringify({ id: regionId }),
  });
  return normalize(data);
}

export async function fetchWards(councilId) {
  const data = await fetchApi(`${LOCATION_API_URL}/wards`, {
    method: 'POST',
    body: JSON.stringify({ id: councilId }),
  });
  return normalize(data);
}

export async function fetchStreets(wardId) {
  const data = await fetchApi(`${LOCATION_API_URL}/streets`, {
    method: 'POST',
    body: JSON.stringify({ id: wardId }),
  });
  return normalize(data);
}

export async function fetchRoads(streetId) {
  const data = await fetchApi(`${LOCATION_API_URL}/roads`, {
    method: 'POST',
    body: JSON.stringify({ id: streetId }),
  });
  return normalize(data);
}

export async function fetchHouses(roadId) {
  const data = await fetchApi(`${LOCATION_API_URL}/houses`, {
    method: 'POST',
    body: JSON.stringify({ id: roadId }),
  });
  return data.houses || [];
}

export async function fetchHouseInfo(roadId, addressId) {
  const data = await fetchApi(`${LOCATION_API_URL}/house-info`, {
    method: 'POST',
    body: JSON.stringify({ roadId, addressId }),
  });
  return data;
}
